export default function loadYoutubeAPI() {
	let script = document.createElement('script');
	script.src = 'https://www.youtube.com/player_api';
	document.querySelector('head').appendChild(script);
}



// WEBPACK FOOTER //
// ./assets/scripts/utils/loadYoutubeAPI.js